import { useStore, useStoreMap, useGate } from 'effector-react'
import React, { FunctionComponent } from 'react'
import { Form, employeeModel } from '~/entities/Employee'
import { usePermissions } from '~/entities/viewer'
import { Role } from '~/shared/api'
import { formSubmitted, Gate, $employee, employeeUpdateFx } from './model'

type EditEmployeeProps = {
  employeeId: string
}

export const EditEmployee: FunctionComponent<EditEmployeeProps> = ({
  employeeId,
}) => {
  useGate(Gate, { employeeId })
  const { canUsersUpdate } = usePermissions()

  const isLoading = useStore(employeeModel.requestFx.pending)
  const isSaving = useStore(employeeUpdateFx.pending)

  const defaultValues = useStoreMap($employee, (employee) => ({
    rolesIds: employee?.getRoles()?.map((role: Role) => role.getOption()),
    ...employee?.getAttributes(),
  }))

  return (
    <Form
      isLoading={isLoading}
      defaultValues={defaultValues}
      onSuccess={formSubmitted}
      isSubmitting={isSaving}
      canEdit={canUsersUpdate}
    />
  )
}
